import React from 'react';
import PrintLayout from './PrintLayout';
import { rolesForDisplay } from '../../utils/roles';

const EXPLANATION = "Often team members will play roles that they don't even realize or silently assign themselves to do things. This can be motivated by loyalty, fear, wisdom, insecurity, and everything in between. These roles are not \"good\" or \"bad\" per se. But they need to be understood so the team is aligned if that member plays a particular role. And they need to come into the light if the role inherently challenges the effectiveness of a team or their meetings.";

function RoleBlock({ label, color, roles, observedRoles }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{
        fontSize: 10, fontWeight: 700, color: 'white',
        background: color, padding: '4px 10px', borderRadius: 4,
        marginBottom: 8, display: 'inline-block',
      }}>
        {label}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {roles.map(role => {
          const tagged = observedRoles?.[role.id];
          return (
            <div key={role.id} style={{ paddingLeft: 4 }}>
              <span style={{ fontSize: 9.5, fontWeight: 700, color: '#1e2e45' }}>{role.name}</span>
              <span style={{ fontSize: 9, color: '#6b757e' }}> — {role.description}</span>
              {tagged && tagged.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 3 }}>
                  {tagged.map(name => (
                    <span key={name} style={{
                      fontSize: 7.5, fontWeight: 700,
                      background: '#eef3e8', color: '#5f7942',
                      padding: '1px 6px', borderRadius: 8,
                    }}>
                      {name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function PrintRoles({ pageNumber, observedRoles }) {
  return (
    <PrintLayout pageNumber={pageNumber}>
      <div style={{
        position: 'absolute', top: 0, bottom: 68, left: 0, right: 0,
        display: 'flex', background: '#f5f4f0',
      }}>
        {/* Sidebar */}
        <div style={{
          width: '32%', padding: '6% 5%',
          background: '#1e2e45',
          display: 'flex', flexDirection: 'column',
        }}>
          <div style={{
            fontSize: 9, fontWeight: 700, letterSpacing: '2px', color: '#5f7942',
            textTransform: 'uppercase', marginBottom: 10, fontFamily: 'Montserrat, sans-serif',
          }}>
            Team Dynamics
          </div>
          <div style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 22, fontWeight: 700, color: 'white', marginBottom: 14, lineHeight: 1.2,
          }}>
            Inventory of Roles
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.65)', lineHeight: 1.75 }}>
            {EXPLANATION}
          </div>
        </div>

        {/* Main content */}
        <div style={{ flex: 1, padding: '5% 5%', overflowY: 'hidden' }}>
          <RoleBlock
            label="Roles that affect Process"
            color="#2a3d5b"
            roles={rolesForDisplay('simpleProcess', observedRoles)}
            observedRoles={observedRoles}
          />
          <RoleBlock
            label="Roles that affect Content"
            color="#5f7942"
            roles={rolesForDisplay('compellingContent', observedRoles)}
            observedRoles={observedRoles}
          />
        </div>
      </div>
    </PrintLayout>
  );
}
